<template>
  <div class="content-table">
    <div class="content-row">
      <div style="width:45%;position: relative;margin-top: 3%;">
        <input type="text" class="search_input" v-model="key_word" @keyup.enter="search"/>
        <img src="/index/static/icon/kuaisusousuo.png" class="search_img"  @click="search" />
      </div>
    </div>
    <template>
      <el-table
        :data="data"
        height="500"
        :header-cell-style="rowStyle"
        class="content-row table_scroll"
        fixed
        @selection-change="handleSelectionChange"
      >
        <el-table-column prop="good_code" border label="商品代码"></el-table-column>
        <el-table-column prop="good_name" border label="商品名称"></el-table-column>
        <el-table-column prop="good_spec" border label="规格型号"></el-table-column>
        <el-table-column prop="unit_name" border label="单位"></el-table-column>
        <el-table-column prop="batch" border label="批号"></el-table-column>
        <el-table-column prop="price" border label="单价"></el-table-column>
        <el-table-column prop="0" border label="数量" width="150">
          <template slot-scope="scope">
            <el-input-number v-model="data[scope.$index].qty" value="aaa" :min="0" size="small"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <div @click="addcart(scope.row)">
              <img src="/index/static/icon/gouwucart.png" class="pointer" />
            </div>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <div class="customer-management-footer">
      <el-pagination
        class="table-page"
        :current-page.sync="page"
        :page-size="pagesize"
        layout="prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        v-if="total !=0"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
var total_row = [];
export default {
  name: "",
  components: {},

  data() {
    return {
      data: [],
      rowStyle: {
        color: "#fff",
        background: "#52a6ee"
      },
      total: 0,
      pagesize: 10,
      key_word: "",
      current_page: "",
      last_page: "",
      per_page: "",
      total: "",
      qty: "0",

    };
  },
  mounted() {
    this.view();
  },
  watch: {
    currentPage(oldV, newV) {
      
    },
    page: "view",
    pagesize: "view"
  },
  methods: {
    view() {
      //   this.$axios({
      //     method: "post",
      //     url: "/index/catalogue/good_sku",
      //     params: {
      //     //   user: "",
      //       keyword: this.key_word,
      //     //   pagesize: "",
      //     //   page: ""
      //     }
      //   })
      //     .then(res => {
      //       this.data = res.data.data.data;
      //       this.current_page = res.data.data.current_page;
      //       this.last_page = res.data.data.last_page;
      //       this.per_page = res.data.data.per_page;
      //       this.total = res.data.data.total;
      //     })
      //     .catch(err => {
      //       this.$message(err);
      //     });
    },
    handleSelectionChange(row) {
      this.row = row;
      total_row = row;
      var a = 0;
      var c = 0;
      for (let i = 0; i < total_row.length; i++) {
        c = total_row[i].qty * total_row[i].price;
        a += c;
      }
     
      this.sums = a;
    },
    search() {
      if (this.key_word == "") {
        this.$message1("请输入商品名称关键字");
      } else {
        this.$axios({
          method: "post",
          url: "/index/catalogue/good_sku",
          params: {
            user: "",
            keyword: this.key_word,
            pagesize: "",
            page: ""
          }
        })
          .then(res => {
            this.data = res.data.data.data;
            this.current_page = res.data.data.current_page;
            this.last_page = res.data.data.last_page;
            this.per_page = res.data.data.per_page;
            this.total = res.data.data.total;
          })
          .catch(err => {
            this.$message(err);
          });
      }
    },
    addcart(data) {
      if (data.qty < 1) {
        this.$message1("请至少选择一件商品");
      } else {
        this.$axios({
          method: "post",
          url: "/index/cart/add_cart",
          params: {
            sku_good_code: data.sku_good_code,
            qty: data.qty
          }
        })
          .then(res => {
            this.$message1(res.data.msg);
          })
          .catch(err => {
            this.$message(err);
          });
      }
    },
    handleSizeChange: function(val) {
      
      this.pagesize = val;
      
    },
    handleCurrentChange: function(val) {
      
      
      this.page = val;
      this.setContextData("page", this.page);
    }
  }
};
</script>
<style lang="less" scoped>
.search_input {
  height: 35px;
  border: 2px solid rgba(207, 149, 93, 1);
  width: 100%;
}
.search_img {
  position: absolute;
  top: 32%;
  right: 4%;
  cursor: pointer;
}
.pointer {
  cursor: pointer;
}
.settlement_row {
  width: 99%;
  height: 70px;
  // background: red;
  text-align: left;
}
.cate-menu {
  width: 99%;
  // background-color: #2d8de4;
  float: left;
  height: 50px;
  line-height: 50px;
  padding-left: 0;
  margin-bottom: 2.5%;
  border: 1px solid #ebeef5;
}
.cate-menu li {
  float: left;
  width: auto;
  list-style-type: none;
  margin: 0 3% 0 0;
  // color: #fff;
  height: 100%;
  padding-left: 4%;
  cursor: pointer;
  text-align: left;
}
.pay_btn {
  height: 100%;
  width: 10%;
  background-color: #2d8de4;
  color: #fff;
  border: none;
}
.color {
  color: red;
  font-size: 16px;
}
.good_pic {
  width: 90px;
  height: 100px;
}
.good_datails {
  display: inline-block;
  margin-top: 6%;
  padding-left: 5%;
  font-size: 12px;
}
.discount {
  width: 55%;
}
.table_scroll ::-webkit-scrollbar {
  width: 0px; /*滚动条宽度*/
  height: 5px; /*滚动条高度*/
  background-color: white;
  margin-right: 10px;
}

/*定义滑块 内阴影+圆角*/
.table_scroll ::-webkit-scrollbar-thumb {
  -webkit-box-shadow: inset 0 0 6px #f5f7fa;
  background-color: rgba(221, 222, 224); /*滚动条的背景颜色*/
}
.el-table__fixed-right-patch {
  width: 0px; /*滚动条宽度*/
}
.table-page {
  margin-bottom: 6%;
}
</style>



// WEBPACK FOOTER //
// src/components/Quick_order/index.vue